<template>
  <div v-if="true" class="line-loading-container">
    <div :style="`width: ${size}px; background: ${color};`" class="loading-line line"></div>
  </div>
</template>

<script>
export default {
  name: "LineLoading",
  props: {
    size: String | Number,
    color: String | Number
  }
};
</script>

<style lang="scss" scoped>
@keyframes loadingGrow {
  0% {
    transform: scaleX(0);
    transform-origin: left;
  }
  39% {
    transform: scaleX(1);
    transform-origin: left;
  }
  40% {
    transform: scaleX(1);
    transform-origin: right;
  }
  80% {
    transform: scaleX(0);
    transform-origin: right;
  }
}
.loading-line {
  height: 1px;
  width: 100%;
  background: var(--preto);
  // border-radius: 10px;
  margin: 1px;
  z-index: 10;
}
.line-loading-container {
  display: flex;
  width: 100%;
  padding: 0 13px;
}
.line {
  transform: scaleX(0);
  animation: loadingGrow 2s infinite ease-in-out;
}
</style>
